import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const GrievancePolicy = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', py: 6 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
            Grievance Redressal Policy
          </Typography>
          <Divider sx={{ mb: 4 }} />
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            At Shoora Welfare, we are committed to providing proactive customer service and ensuring customer satisfaction. This policy outlines the framework for addressing and resolving customer grievances in a fair, transparent, and timely manner.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Objective
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            The objective of this policy is to minimize and resolve customer grievances effectively through a structured redressal mechanism. It ensures compliance with regulatory guidelines and adherence to fair practices.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Definitions
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            <strong>Grievance/Complaint:</strong> An expression of dissatisfaction with a product or service, either orally or in writing, from a customer. This may arise due to genuine concerns, misunderstandings, or unreasonable expectations.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Grievance Redressal Mechanism
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            To address customer grievances effectively, Shoora Welfare provides multiple channels of communication:
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: 'text.primary' }}>
            1. <strong>Branch Offices:</strong> Designated Grievance Redressal Officers at each branch will handle grievances originating at their respective branches.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: 'text.primary' }}>
            2. <strong>Drop Boxes:</strong> Customers can submit grievances, complaints, or suggestions in drop boxes available at branch offices.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: 'text.primary' }}>
            3. <strong>Customer Care Number:</strong> Customers can call our Customer Care Number at <strong>(+91) 8299866226</strong>, which is displayed at all branch offices.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: 'text.primary' }}>
            4. <strong>Email or Postal Mail:</strong> Customers can send grievances via email to <strong>shoorawelfare@gmail.com</strong> or by postal mail to:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary', pl: 2 }}>
            Shoora Welfare Foundation<br />
            120/40/2B/1A, Kasari Masari, Prayagraj, U.P 211011
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Grievance Redressal Time Frame
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            All grievances will be acknowledged within 2 working days and resolved within 7 working days. If unresolved within 30 days, customers may escalate the complaint as per the escalation matrix.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Escalation Matrix
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: 'text.primary' }}>
            <strong>Level 1:</strong> If unsatisfied with the branch-level resolution, escalate to:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary', pl: 2 }}>
            Customer Service Department<br />
            Shoora Welfare Foundation<br />
            120/40/2B/1A, Kasari Masari, Prayagraj, U.P 211011<br />
            Email: <strong>shoorawelfare@gmail.com</strong><br />
            Phone: <strong>(+91) 8299866226</strong>
          </Typography>
          {/* <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: 'text.primary' }}>
            <strong>Level 2:</strong> If unresolved within one month, escalate to:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary', pl: 2 }}>
            Officer-in-Charge<br />
            Reserve Bank of India<br />
            Department of Non-Banking Supervision<br />
            16/82, A-5, Mall Rd, Near Westcott School,<br />
            Civil Lines, Kanpur-208001, U.P
          </Typography> */}

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Monitoring and Review
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            Periodic reviews of grievances and their resolutions will be conducted to identify trends, address process gaps, and improve service delivery.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Policy Review
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            This policy will be reviewed annually by the Board of Directors to ensure compliance with regulatory changes and organizational needs. It will be available on our website and at all branch offices.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.primary' }}>
            For any queries or concerns regarding this policy, please contact us at <strong>shoorawelfare@gmail.com</strong>.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default GrievancePolicy;
